import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";

import { BookingConfirmation } from "../../components/organisms";
import { actionCreators as categoriesActions } from "../../store/categories/actions";
import { actionCreators as checkoutActions } from "../../store/checkout/actions";
import { actionCreators as therapistsActions } from "../../store/therapists/actions";
import { actionCreators as treatmentsActions } from "../../store/treatments/actions";

type RouteProps = RouteComponentProps;
type Props = RouteProps & { dispatch: Dispatch<any> };

class ConfirmationContainer extends React.Component<Props> {
  /**
   * No need to re-render again
   */
  public shouldComponentUpdate() {
    return false;
  }

  // reset store
  public componentWillUnmount() {
    this.props.dispatch(categoriesActions.clearCategory());
    this.props.dispatch(treatmentsActions.clearTreatments());
    this.props.dispatch(therapistsActions.deSelectTherapist());
    this.props.dispatch(therapistsActions.clearDate());
    this.props.dispatch(checkoutActions.clearCheckout());
  }

  /**
   * Render confirmation component
   */
  public render() {
    return this.props.location.state ? (
      <BookingConfirmation {...this.props.location.state} />
    ) : (
      <Redirect to="/" />
    );
  }
}

const store = withRouter(connect()(ConfirmationContainer));

export { store as ConfirmationContainer };
